import React from 'react';
import './src/styles/global.css';
import { BizProvider } from './src/components/BizContext';
import { MotionProvider } from './src/components/MotionProvider';
import Layout from './src/components/Layout';

export const wrapRootElement = ({ element }) => (
  <BizProvider>
    <MotionProvider>{element}</MotionProvider>
  </BizProvider>
);

export const wrapPageElement = ({ element, props }) => <Layout {...props}>{element}</Layout>;
